module.exports = __webpack_public_path__ + "static/media/YM17_1.d82ef6a2.jpg";